import { recordEvent } from '@department-of-veterans-affairs/platform-monitoring/exports';

/**
 * Reports one load of the combined submission history: how many rows came
 * back and how long the page took to show them. These two numbers decide
 * when the history moves to server-side paging, so they are reported from
 * the first real load on. Named rather than inlined so specs can stub it.
 *
 * @param {Object} load
 * @param {'representative'|'claimant'} load.scope Which history page.
 * @param {'table'|'card'} load.view Which view showed the rows.
 * @param {number} load.rowCount Rows received from both sources.
 * @param {number} load.loadToRenderMs From the route loader's entry to the
 *   rows rendering.
 */
export const recordSubmissionHistoryLoad = ({
  scope,
  view,
  rowCount,
  loadToRenderMs,
}) =>
  recordEvent({
    event: 'arp-submission-history-load',
    'history-scope': scope,
    'history-view': view,
    'row-count': rowCount,
    'load-to-render-ms': Math.round(loadToRenderMs),
  });

export const recordDatalayerEvent = e => {
  const sendEvent = () =>
    recordEvent({
      // prettier-ignore
      'event': e.target.dataset.eventname,
    });
  switch (e.target.dataset.eventname) {
    case 'nav-tab-click':
      recordEvent({
        // prettier-ignore
        'event': e.target.dataset.eventname,
        // prettier-ignore
        'tab text': e.target.innerText,
      });
      break;
    case 'cta-button-click':
      recordEvent({
        // prettier-ignore
        'event': e.target.dataset.eventname,
        // prettier-ignore
        'button-label': e.target.innerText,
      });
      break;
    case 'nav-header-sign-in':
      sendEvent();
      break;
    case 'nav-header-sign-out':
      sendEvent();
      break;
    case 'arp-card':
      sendEvent();
      break;
    case 'int-radio-button-option-click':
      recordEvent({
        // prettier-ignore
        'event': e.target.dataset.eventname,
        // prettier-ignore
        'radio-button-label': 'Do you accept or decline this POA request?',
        'radio-button-optionLabel': e.target.innerText,
        'radio-button-required': 'true',
      });
      break;
    default:
      recordEvent({
        // prettier-ignore
        'event': e.target.dataset.eventname,
        // prettier-ignore
        'custom_string_2': e.target.innerText || e.target.alt,
        'link-destination': e.target.href || e.target.baseURI,
        'link-origin': 'navigation',
      });
  }
};
